module.exports = __webpack_public_path__ + "img/image-prev.02b0217f.png";